module.exports = __webpack_public_path__ + "img/sticker-0-0--1.c8005bd0.svg";